if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!recommendationsHTML) return;
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;

          const accordionWrapper = this.closest('[data-complementary-accordion]');
          if (accordionWrapper) {
            accordionWrapper.classList.remove('hidden');
            const titleEl = accordionWrapper.querySelector('[data-complementary-title]');
            if (titleEl) {
              const defaultTitle = titleEl.textContent.trim();
              this.querySelectorAll('.product-recommendations__item').forEach(item => {
                const productTitleEl = item.querySelector('.product-recommendations__item-title');
                if (productTitleEl) {
                  item.addEventListener('mouseenter', () => {
                    titleEl.textContent = productTitleEl.textContent.trim();
                  });
                  item.addEventListener('mouseleave', () => {
                    titleEl.textContent = defaultTitle;
                  });
                }
              });
            }
          }

          this.initSlider();

          if (accordionWrapper) {
            const detailsEl = accordionWrapper.querySelector('details');
            if (detailsEl) {
              detailsEl.addEventListener('toggle', () => {
                if (detailsEl.open && this.slider) {
                  this.slider.update();
                }
              });
            }
          }

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);

        });
    }

    initSlider() {
      if (this.closest('[data-complementary-accordion]')) return;
      if (this.classList.contains('cart-drawer__recommendations')) return;
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
